/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Logic from 'fierry/data/logic';

import * as ArrayUtil from 'fierry/util/array';

import ColonyCass from 'solis/logic/board/colony/cass';
import BoardSectorGeometry from 'solis/logic/board/sector/geometry';


export default class BoardProximity extends Logic
{
  constructor (board, type)
  {
    super(board);

    this.type = type;

    this.index = new Map();

    for (const colony of board.getColonies().values())
    {
      const colonyCass = new ColonyCass(colony);

      if (colonyCass.hasCoreSector())
      {
        this.initializeColonyProximity(colonyCass.getCoreSector());
      }
    }
  }


  isAccessibleByUser (hex, userID)
  {
    const colonies = this.index.get(hex.toString()) ?? new Map();

    for (const colonyID of colonies.keys())
    {
      if (this.object.getColony(colonyID).cass.user === userID)
      {
        return true;
      }
    }

    return false;
  }


  isAccessibleByColony (hex, colonyID)
  {
    return this.index.get(hex.toString())?.has(colonyID) ?? false;
  }


  isGroupAccessibleByColony (group, colonyID)
  {
    for (const hex of group)
    {
      if (!this.isAccessibleByColony(hex, colonyID))
      {
        return false;
      }
    }

    return true;
  }


  getClosestColony (group)
  {
    const colonies = new Map();

    for (const hex of group)
    {
      for (const [ colonyID, distance ] of this.index.get(hex.toString()) ?? [])
      {
        colonies.set(colonyID, (colonies.get(colonyID) ?? 0) + distance);
      }
    }

    return ArrayUtil.findMin([ ...colonies.keys() ].sort(), colonyID => colonies.get(colonyID));
  }


  initializeColonyProximity (sector)
  {
    const id = sector.cass.id;
    const geometry = new BoardSectorGeometry(sector);

    for (const hex of geometry.getZoneGroup(this.type))
    {
      this.getLocationIndex(hex).set(id, 0);
    }

    for (let frontier = geometry.getZoneFrontier(this.type); !frontier.empty(); frontier.expand())
    {
      for (const hex of frontier)
      {
        this.getLocationIndex(hex).set(id, frontier.getDistance());
      }
    }
  }


  getLocationIndex (hex)
  {
    if (!this.index.has(hex.toString()))
    {
      this.index.set(hex.toString(), new Map());
    }

    return this.index.get(hex.toString());
  }


};
